// Skeleton.styles.ts
import styled from 'styled-components';

import { SkeletonProfileImage, SkeletonBody } from '@xing-com/skeleton';
import { scale050, spaceXS, spaceXXS } from '@xing-com/tokens';

export const Container = styled.div`
  display: flex;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex: 1;

  &:hover {
    text-decoration: none;
  }
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const LogoImageContainer = styled(SkeletonProfileImage)`
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-right: ${scale050};

  & > div {
    height: 100%;
  }
`;

export const TitleSkeleton = styled(SkeletonBody)`
  margin-bottom: ${spaceXXS};
`;

export const BodySkeleton = styled(SkeletonBody)`
  width: 85%;

  & div:first-child {
    margin-bottom: ${spaceXS};
  }
`;
